/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ kcal: NonNullable<unknown> }} Planner_Kcal_DayInputs */

const en_planner_kcal_day = /** @type {(inputs: Planner_Kcal_DayInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`≈ ${i?.kcal} per person and day`)
};

const de_planner_kcal_day = /** @type {(inputs: Planner_Kcal_DayInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`≈ ${i?.kcal} pro Person und Tag`)
};

/**
* | output |
* | --- |
* | "≈ {kcal} per person and day" |
*
* @param {Planner_Kcal_DayInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const planner_kcal_day = /** @type {((inputs: Planner_Kcal_DayInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Planner_Kcal_DayInputs, { locale?: "en" | "de" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_planner_kcal_day(inputs)
	return en_planner_kcal_day(inputs)
});